import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LOGO_URL } from "../lib/api";
import AIAssistant from "./AIAssistant";
import StockAlerts from "./StockAlerts";
import {
  LayoutDashboard, ShoppingCart, Package, Wrench, DollarSign,
  Users, Truck, UserCog, MessageSquare, BarChart3, Settings, LogOut, Globe, ScanSearch, CreditCard, FileUp, FileCheck2, Receipt, Search, Sparkles, Bot, ClipboardList, CalendarClock
} from "lucide-react";

const NAV = [
  { to: "/app/dashboard", icon: LayoutDashboard, label: "Dashboard" },
  { to: "/app/pdv", icon: ShoppingCart, label: "PDV" },
  { to: "/app/products", icon: Package, label: "Estoque" },
  { to: "/app/import-nf", icon: FileUp, label: "Importar NF" },
  { to: "/app/service-orders", icon: Wrench, label: "Ordens de Serviço" },
  { to: "/app/services-catalog", icon: ClipboardList, label: "Tabela de Serviços" },
  { to: "/app/imei-lookup", icon: Search, label: "Consulta IMEI" },
  { to: "/app/phone-identifier", icon: ScanSearch, label: "Identificar Aparelho" },
  { to: "/app/up-club", icon: Sparkles, label: "UP Club" },
  { to: "/app/infinitepay", icon: CreditCard, label: "InfinitePay" },
  { to: "/app/financial", icon: DollarSign, label: "Financeiro" },
  { to: "/app/expenses", icon: Receipt, label: "Gastos" },
  { to: "/app/customers", icon: Users, label: "Clientes" },
  { to: "/app/suppliers", icon: Truck, label: "Fornecedores" },
  { to: "/app/employees", icon: UserCog, label: "Funcionários" },
  { to: "/app/messages", icon: MessageSquare, label: "WhatsApp / Insta" },
  { to: "/app/whatsapp-ai", icon: Bot, label: "IA WhatsApp" },
  { to: "/app/automations", icon: CalendarClock, label: "Reservas e Automações" },
  { to: "/app/reports", icon: BarChart3, label: "Relatórios" },
  { to: "/app/fiscal", icon: FileCheck2, label: "Notas Fiscais" },
  { to: "/app/settings", icon: Settings, label: "Configurações" },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen flex bg-[#F8FAFC]">
      {/* Sidebar */}
      <aside className="w-64 brand-navy text-white flex flex-col" data-testid="sidebar">
        <div className="p-5 border-b border-white/5 flex items-center gap-3">
          <div className="w-10 h-10 rounded-sm overflow-hidden bg-white/5 flex items-center justify-center">
            <img src={LOGO_URL} alt="UP CEL Quilombo" className="w-full h-full object-cover" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-display font-bold text-lg tracking-tight truncate">UP CEL Quilombo</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-blue-300">Gestão</div>
          </div>
          <StockAlerts />
        </div>

        <nav className="flex-1 p-3 space-y-0.5 overflow-y-auto scrollbar-thin">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.to.split("/").pop()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm transition-colors ${
                  isActive
                    ? "bg-[#2563EB] text-white font-semibold"
                    : "text-slate-300 hover:bg-white/5 hover:text-white"
                }`
              }
            >
              <item.icon size={18} />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-white/5 space-y-2">
          <a
            href="/catalog"
            target="_blank"
            rel="noreferrer"
            data-testid="public-catalog-link"
            className="flex items-center gap-2 px-3 py-2 text-xs text-blue-300 hover:text-white"
          >
            <Globe size={14} /> Ver catálogo público
          </a>
          <div className="px-3 py-2 text-xs text-slate-400">
            <div className="truncate">{user?.name || user?.email}</div>
            <div className="text-[10px] uppercase tracking-wider text-blue-400">{user?.role}</div>
          </div>
          <button
            onClick={async () => { await logout(); nav("/login"); }}
            data-testid="logout-btn"
            className="flex items-center gap-2 w-full px-3 py-2 text-sm text-red-300 hover:bg-red-500/10 rounded-sm"
          >
            <LogOut size={16} /> Sair
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 overflow-auto">
        <div className="p-6 lg:p-8 max-w-[1500px] mx-auto">
          <Outlet />
        </div>
      </main>

      <AIAssistant />
    </div>
  );
}
